import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-upload-img',
  templateUrl: './upload-img.component.html',
  styleUrls: ['./upload-img.component.scss'],
})
export class UploadImgComponent implements OnInit {
  @Input() img = undefined;
  @Input() action = '';
  @Input() canClose = true;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    
  }

  close(){
    this.modalController.dismiss('close');
  }

  async save(){
    await this.modalController.dismiss(this.action);
  }
}
